import React from 'react';
import PropTypes from 'prop-types';

import './GravityLayout.scss';

function GravityLayout({ classes = '', children }) {
  return <div className={`gravityLayout ${classes}`}>{children}</div>;
}

GravityLayout.propTypes = {
  classes: PropTypes.instanceOf(Object),
  children: PropTypes.node.isRequired,
};

GravityLayout.defaultProps = {
  classes: '',
};

export default GravityLayout;
